import reducers from '../reducers';
import { genericStoreSetup } from 'reactifi';

export default props => {
  const { api, routing, capabilitiesReducer } = props;
  const store = { api, routing, capabilitiesReducer };
  return genericStoreSetup(reducers, store);
};